"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AuthorCardModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorCardModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const form_1 = require("../_abstract/form");
const _contracts_1 = require("../_contracts");
const backoffice_1 = require("../../dsl/backoffice");
const services_1 = require("../../services");
const AuthorCard_contracts_1 = require("./AuthorCard.contracts");
/**
 * @author Michał Rossian <michal.rossian@movecloser.pl>
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
let AuthorCardModuleForm = AuthorCardModuleForm_1 = class AuthorCardModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        //
        this.author = null;
        this.icons = backoffice_1.DashmixIconName;
        this.moduleModes = _contracts_1.ModuleMode;
        this.variants = AuthorCard_contracts_1.AuthorCardSelectionOption;
        this.variant = AuthorCard_contracts_1.AuthorCardSelectionOption.Default;
        this.initialContent = AuthorCardModuleForm_1.getInitialContent();
    }
    get options() {
        const options = [{
                label: `${this.$t('forms.shared.selectionModes.default')}`,
                value: AuthorCard_contracts_1.AuthorCardSelectionOption.Default
            },
            {
                label: `${this.$t('forms.shared.selectionModes.auto')}`,
                value: AuthorCard_contracts_1.AuthorCardSelectionOption.Smart
            }];
        return options;
    }
    /**
     * Picked Author
     */
    get selectedAuthor() {
        if (!this.author) {
            return {};
        }
        return this.author[0];
    }
    /**
     * Picked author's avatar
     */
    get selectedAuthorAvatar() {
        return this.selectedAuthor.firstName + ' ' + this.selectedAuthor.lastName;
    }
    /**
     * Picked author's position
     */
    get selectedAuthorPosition() {
        if (!this.selectedAuthor.position) {
            return '';
        }
        return this.selectedAuthor.position;
    }
    get canShowAbout() {
        return this._content.showAbout;
    }
    set canShowAbout(val) {
        this._content.showAbout = val;
    }
    get hasHeader() {
        return this._content.canShowHeader;
    }
    set hasHeader(val) {
        this._content.canShowHeader = val;
    }
    changeAuthorVariant(value) {
        this.variant = value;
        if (value === AuthorCard_contracts_1.AuthorCardSelectionOption.Smart) {
            this._content.authorRelated = { type: services_1.RelatedType.ExtendedAuthor, value: '##AUTHOR_ID##' };
            this._content.authorType = AuthorCard_contracts_1.AuthorCardSelectionOption.Smart;
        }
        else {
            this._content.authorRelated = {};
            this._content.authorType = AuthorCard_contracts_1.AuthorCardSelectionOption.Default;
        }
    }
    deleteAuthor() {
        this.author = null;
        this._content.authorRelated = null;
    }
    findAuthorSource() {
        this.pickRelated(services_1.Picker.Author, this.setAuthor);
    }
    static getInitialContent() {
        return {
            showAbout: false,
            canShowHeader: false,
            authorRelated: {
                type: services_1.RelatedType.ExtendedAuthor,
                value: 0
            }
        };
    }
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.AuthorCard,
            size: {
                colSpan: 6,
                rowSpan: 3,
                minRowSpan: 3,
                minColSpan: 6,
                isResizable: false
            }
        };
    }
    describeAuthor(author) {
        //
        this.relatedService.describe(author).then(related => {
            //
            this.author = { ...this.author, [author.value]: related };
            if (related.avatar && typeof related.avatar.value !== 'undefined') {
                this.describe(related.avatar, 'url');
            }
        }).catch((e) => {
            console.warn(e);
        });
    }
    setAuthor(related) {
        this._content.authorRelated = related;
        this.describeAuthor(related);
    }
    setActiveVariant() {
        //
        if (!this._content.authorRelated) {
            return;
        }
        switch (this._content.authorRelated.value) {
            case '##AUTHOR_ID##':
                this.variant = AuthorCard_contracts_1.AuthorCardSelectionOption.Smart;
                break;
            case -3:
                this.variant = AuthorCard_contracts_1.AuthorCardSelectionOption.Smart;
                break;
            default:
                this.variant = AuthorCard_contracts_1.AuthorCardSelectionOption.Default;
        }
    }
};
AuthorCardModuleForm = AuthorCardModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'AuthorCardModuleForm',
        components: { DashmixButton: backoffice_1.DashmixButton, DashmixSelect: backoffice_1.DashmixSelect, DashmixAvatar: backoffice_1.DashmixAvatar, DashmixCheck: backoffice_1.DashmixCheck },
        /**
         * Vue lifecycle hook.
         */
        mounted() {
            //
            this.setActiveVariant();
            if (this._content.authorType === AuthorCard_contracts_1.AuthorCardSelectionOption.Smart && this.mode === this.moduleModes.Smart) {
                return;
            }
            this.$nextTick(() => {
                if (!this._content.authorRelated) {
                    return;
                }
                this.describeAuthor(this._content.authorRelated);
            });
        },
        template: `
    <div>
    <div class="row mb-3">
      <div class="col-3" v-if="mode === moduleModes.Smart">
        <DashmixSelect :model="variant" @update:model="changeAuthorVariant" :options="options"/>
      </div>
        <div class="col-3" v-if="variant === variants.Default && !author">
          <DashmixButton variant="alt" :icon="icons.SearchSolid" :label="$t('forms.shared.search')"
                         @click="findAuthorSource"/>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <DashmixCheck class="mb-2" :label="$t('forms.shared.canShowAbout')" name="hasAbout"
                      :model.sync="canShowAbout" />
      </div>
      <div class="col-4">
        <DashmixCheck class="mb-2" :label="$t('forms.shared.hasHeader')" name="hasHeader"
                      :model.sync="hasHeader" />
      </div>
    </div>
      <template v-if="author" class="row">
        <div class="bg-light py-3 row mx-0 mb-3">
          <div class="col-11 d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <DashmixAvatar size="x-large" :source="selectedAuthor.firstName.src" :person="selectedAuthorAvatar" />
              <p class="pl-3 mb-0">{{ selectedAuthor.firstName }} {{ selectedAuthor.lastName }} <span><i> ({{ selectedAuthorPosition }})</i></span></p>
            </div>
          </div>

          <div class="col-1 d-flex align-items-center p-0">
            <DashmixButton variant="icon" :icon="icons.TrashSolid" theme="danger"
                           @click="deleteAuthor" />
          </div>
        </div>
      </template>
    </div>
  `
    })
], AuthorCardModuleForm);
exports.AuthorCardModuleForm = AuthorCardModuleForm;
exports.default = AuthorCardModuleForm;
//# sourceMappingURL=AuthorCard.form.js.map